// The flow stepper (FLAGSHIPS Phase 1 component, first consumer: the
// cobro register — Carrito → Cobro → Listo). Implements .fs-stage*
// from ui_kits/rehaut-flagships/flagship.css.
import { Fragment } from 'react';
import { Icon } from './Icon';

export function Stage({ stages, current }: { stages: string[]; current: number }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 22 }}>
      {stages.map((label, i) => (
        <Fragment key={label}>
          {i > 0 && (
            <span
              style={{ width: 28, height: 1, background: 'var(--hairline-strong)' }}
              aria-hidden="true"
            />
          )}
          <span
            className={`fs-stage${i === current ? ' active' : i < current ? ' done' : ''}`}
            aria-current={i === current ? 'step' : undefined}
          >
            <span className="fs-stage-dot">
              {i < current ? <Icon name="check" size={11} /> : i + 1}
            </span>
            <span className="fs-stage-label">{label}</span>
          </span>
        </Fragment>
      ))}
    </div>
  );
}
